import { Basket } from '$core/models/subscription-order';
import { Pipe, PipeTransform } from '@angular/core';
export type Periods = 'first' | 'second';
@Pipe({
  name: 'subsByType',
})
export class SubscriptionTypePipe implements PipeTransform {
  public transform(value: Basket[], type?: string, period?: Periods): any {
    if (!value) {
      return value;
    }
    let filtered = value.filter((e) =>
      type ? e.delivery_type === type : true
    );
    filtered = filtered.filter((e) => {
      if (period === 'first') {
        return e.basketable.start_at.indexOf('-01-') === 4;
      } else {
        return e.basketable.start_at.indexOf('-07-') === 4;
      }
    });
    return filtered;
  }
}
